import { WatchQueryFetchPolicy } from '@apollo/client';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import type {
  GetPublicLessonActivitiesQuery,
  GetPublicLessonActivitiesQueryVariables,
} from './get-public-lesson-activities.graphql.generated';
import { GET_PUBLIC_LESSON_ACTIVITIES } from './get-public-lesson-activities.graphql';
import { ActivitiesFontSize, LanguageCodes } from 'global/constants';
import { useActivityBuilderTheme } from '../theme/activity-builder-theme';

export const useGetPublicLessonActivities = ({
  contentId,
  version,
  skip,
  fetchPolicy,
  language,
  onCompleted,
}: {
  contentId: number;
  version?: string | null;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
  language?: LanguageCodes;
  onCompleted?: (res: GetPublicLessonActivitiesQuery) => void;
}) => {
  const { updateFontSize } = useActivityBuilderTheme();

  const { data, loading, error } = useLoggingQuery<
    GetPublicLessonActivitiesQuery,
    GetPublicLessonActivitiesQueryVariables
  >(
    GET_PUBLIC_LESSON_ACTIVITIES,
    {
      fetchPolicy,
      skip,
      variables: {
        input: {
          contentId,
          version: version || null,
          language,
        },
      },
      onCompleted: res => {
        onCompleted?.(res);
        if (res.getPublicLessonActivities.styles) {
          updateFontSize(
            res.getPublicLessonActivities.styles.fontSize as ActivitiesFontSize
          );
        }
      },
    },
    false
  );

  return {
    data,
    loading,
    error,
  };
};
